import { findProduto } from "../../../repository/ERP/estoque/ProdutoService";
import {
  findMarketplaces,
  findProdutoMarketplace,
  incluirAnuncio,
  atualizarAnuncio,
  atualizarUsuarioConfiguracoes as usuarioConfiguracoes,
  excluirAnuncio,
  findAllMarketplaces,
  excluirMarketplace,
  vincularAnuncioService,
} from "../../../repository/hub/marketplace/MarketplacesService";

const pathHub = process.env.REACT_APP_URL_API_HUB;
const mlbClient = process.env.REACT_APP_MLB_CLIENT;

export default function useMarketPlacesController() {
  async function pesquisar(
    empresa_cnpj,
    codigo,
    descricao,
    grupo,
    subgrupo,
    estoque,
    marketplace,
    fabricante,
    anuncio,
    pagina,
    quantidadePorPagina,
    colorBackgroundItemJaAnunciado
  ) {
    // Cria as duas consultas assíncronas
    let promisseProduto = findProduto(
      empresa_cnpj,
      codigo,
      descricao,
      grupo ? grupo.id : null,
      subgrupo ? subgrupo.id : null,
      estoque ? estoque.id : null,
      marketplace ? marketplace.id : null,
      fabricante ? fabricante.id : null,
      anuncio,
      pagina,
      quantidadePorPagina
    );

    let promisseMarketplace = findProdutoMarketplace(
      empresa_cnpj,
      marketplace ? marketplace.id : null,
      true,
      false
    );

    // Espera que as consultas terminem
    let result = await promisseProduto;
    let resultMarketplace = await promisseMarketplace;

    if (resultMarketplace.status) {
      return [{ ...resultMarketplace, success: false }];
    }

    if (result && result.success && result.data) {
      // Unir as buscas entre ERP e Marketplace
      let resultado = result.data.produtos.forEach((produtoErp) => {
        let mktplace = {};

        if (resultMarketplace)
          resultMarketplace.forEach((produtoMarketPlace) => {
            if (produtoErp.estoque_id === produtoMarketPlace.produto_id) {
              mktplace = produtoMarketPlace;
            }
          });

        // ID 0 = TODOS
        if (anuncio.id === 0) {
          return { ...mktplace, ...produtoErp };
          // ID 1 = Somente sincronizados
        } else if (anuncio.id === 1 && mktplace !== null)
          return { ...mktplace, ...produtoErp };
        // ID 2 = Não sincronizados
        else if (anuncio.id === 2 && mktplace === null) return produtoErp;
      });

      // Remove todos os itens nulos
      return {
        produtos: resultado
          .filter((item) => {
            return item != null;
          })
          // Adiciona o colorbackground, se existir o id do marketplace
          .map((item) => {
            return {
              ...item,
              backgroundColor: item.marketplace_produto_id
                ? colorBackgroundItemJaAnunciado
                : null,
            };
          }),
        total: result.data.total,
      };
    } else return { produtos: [], total: 0 };
  }

  function atualizarUsuarioConfiguracoes(
    empresa_cnpj,
    marketplaceId,
    enviarDadosFiscais
  ) {
    return usuarioConfiguracoes(empresa_cnpj, marketplaceId, {
      enviarDadosFiscais: enviarDadosFiscais,
    });
  }

  async function buscarProdutosNaoVinculados(empresa_cnpj, marketplace) {
    let produtoMarketplaceNaoVinculado = await findProdutoMarketplace(
      empresa_cnpj,
      marketplace ? marketplace.id : null,
      false,
      true
    );
    return { success: true, data: produtoMarketplaceNaoVinculado };
  }

  async function buscarMarketplaces() {
    return await findAllMarketplaces().then((value) => {
      return value;
    });
  }

  async function buscarMarketplacesEmpresa(empresa_cnpj) {
    return await findMarketplaces(empresa_cnpj).then((value) => {
      return value;
    });
  }

  async function excluirAnuncios(empresa_cnpj, marketplaceId, produtoIds) {
    let promisses = produtoIds.map((id) =>
      excluirAnuncio(empresa_cnpj, marketplaceId, id)
    );
    return await promisses;
  }

  async function vincularMarketplace(empresa_cnpj, marketplaceId) {
    // MercadoLivre - Exceção, precisa de um popUP para logar
    if (marketplaceId === 5) return await vincularMercadolivre(empresa_cnpj);
    else if (marketplaceId === 3)
      return await vincularWoocommerce(empresa_cnpj);
    return null;
  }

  function desvincularMarketplace(
    empresa_cnpj,
    marketplaceId,
    excluirItens = true
  ) {
    return excluirMarketplace(empresa_cnpj, marketplaceId, excluirItens);
  }

  // TODO fazer o vinculo
  function vincularWoocommerce(empresa_cnpj, excluirItens) {
    return null;
  }

  async function vincularMercadolivre(empresa_cnpj) {
    // Encontra o meio da tela, e define o tamanho da nova window
    let width = 800;
    let height = 600;
    let left = window.innerWidth / 2 - width / 2;
    let top = window.innerHeight / 2 - height / 2;

    let popUp = window.open(
      `http://auth.mercadolivre.com.br/authorization?response_type=code&client_id=${mlbClient}&state=${empresa_cnpj}&redirect_uri=${pathHub}/usuario/MLB`,
      "_blank",
      `toolbar=yes,scrollbars=yes,resizable=yes,top=${top},left=${left},width=${width},height=${height}`
    );

    var timer = await setInterval(async function () {
      if (popUp.closed) {
        clearInterval(timer);

        // Espera o anuncio ser criado no marketplace, para atualizar os itens (2 seg)
        setTimeout(async () => {
          let empresasConectadas = await findMarketplaces(empresa_cnpj).then(
            (value) => {
              return value;
            },
            500
          );

          let conectado = false;
          empresasConectadas.forEach((empresa) => {
            if (empresa.id === 5) {
              conectado = true;
              return;
            }
          });

          if (conectado) {
            sessionStorage.setItem("marketplaceId", "5");
            sessionStorage.setItem("tabIndex", 1);
            window.location.reload();
          }
        }, 500);
      }
    }, 1000);

    // popUp.onbeforeunload = () => {
    //   value.location.reload();
    // };
  }

  // Campos:
  //  empresa_cnpj
  //  marketplaceId
  //  id
  //  titulo
  //  preco
  //  quantidade
  //  descricao
  //  fotos
  async function sincronizarProdutos(
    empresa_cnpj,
    marketplaceId,
    produtos = []
  ) {
    // Pré validação, antes de enviar para o marketplace
    if (!validarProdutos(empresa_cnpj, marketplaceId, produtos)) {
      return {
        success: false,
        mensagem: mensagemErroProdutos(empresa_cnpj, marketplaceId, produtos),
      };
    }

    let anuncios = produtos.map((produto) => {
      let fotos = "";
      produto.fotos.forEach((s3) => {
        fotos += s3.s3_key + ",";
      });
      // Remove o último dígito (",")
      produto.fotos = fotos.slice(0, -1);
      produto.descricao = produto.descricao
        ? produto.descricao.replace(/(<([^>]+)>)/gi, "")
        : "";
      return produto;
    });

    return incluirAnuncio(empresa_cnpj, marketplaceId, anuncios)
      .then((value) => {
        // Status (se estiver entre 200 e 300 ou não vier status, é porque conseguiu enviar os produtos)
        let success =
          (value.status >= 200 && value.status < 300) || value.success;

        let erros = "";
        if (!success) {
          if (value.cause)
            value.cause.forEach((value) => {
              if (value.type === "error") erros += value.message + "<br>";
            });
          else erros = value.message ?? value.mensagem;
        }

        return {
          success: success,
          mensagem: success ? value : erros,
        };
      })
      .catch((error) => {
        return {
          success: false,
          mensagem: error,
        };
      });
  }

  async function vincularAnuncio(
    cnpj,
    marketplace,
    produtoErp,
    produtoMarketplace
  ) {
    return vincularAnuncioService(
      cnpj,
      marketplace.id,
      produtoErp.estoque_id,
      produtoMarketplace.marketplace_produto_id
    );
  }

  async function atualizarProdutos(empresa_cnpj, marketplaceId, produtos = []) {
    return atualizarAnuncio(empresa_cnpj, marketplaceId, produtos)
      .then((value) => {
        // Status (se estiver entre 200 e 300 ou não vier status, é porque conseguiu enviar os produtos)
        let success =
          (value.status >= 200 && value.status < 300) || !value.status;

        let erros = "";
        if (!success) {
          value.cause.forEach((value) => {
            if (value.type === "error") erros += value.message + "<br>";
          });
        }

        return {
          success: success,
          mensagem: success ? value : erros,
        };
      })
      .catch((error) => {
        return {
          success: false,
          mensagem: error,
        };
      });
  }

  // Se todos os campos obrigatórios estiverem preenchidos, será válido
  function validarProdutos(empresa_cnpj, marketplaceId, produtos = []) {
    let produtoValido = empresa_cnpj && marketplaceId;
    produtos.forEach((produto) => {
      produtoValido = validarProduto(produto) && produtoValido;
    });

    return produtoValido;
  }

  function validarProduto(produto) {
    return (
      produto.estoque_id &&
      produto.descricao &&
      produto.descricao.length < 60 &&
      produto.preco &&
      0 !== produto.preco &&
      produto.quantidade &&
      0 !== produto.quantidade &&
      produto.especificacoes_tecnica &&
      produto.fotos &&
      produto.fotos !== ""
    );
  }

  function mensagemErroProdutos(empresa_cnpj, marketplaceId, produtos = []) {
    let erro =
      "Ocorreu um problema ao enviar o(s) produto(s).<br>Por favor, verifique os seguintes campos: <br>";

    erro += !empresa_cnpj ? "CNPJ da empresa<br>" : "";
    erro += !marketplaceId ? "Marketplace não encontrado<br>" : "";

    produtos.forEach((produto) => {
      // Ignora caso não encontre nenhum erro
      if (validarProduto(produto)) return;

      // Adiciona o motivo do erro na lista
      erro += !produto.estoque_id ? "Id do produto não encontrado<br>" : "";
      erro += !produto.descricao ? 'Título do produto ""<br>' : "";
      erro +=
        produto.descricao.length > 60
          ? `<b>Título do produto</b> "${produto.descricao}" deve conter no máximo 60 caracteres<br>`
          : "";
      erro +=
        !produto.preco || 0 === produto.preco
          ? `<b>Preço do produto</b> "${produto.descricao}"<br>`
          : "";
      erro +=
        !produto.quantidade || 0 === produto.quantidade
          ? `<b>Quantidade do produto</b> "${produto.descricao}"<br>`
          : "";
      erro += !produto.especificacoes_tecnica
        ? `<b>Descrição do produto</b> "${produto.descricao}<br>`
        : "";
      erro +=
        !produto.fotos || "" === produto.fotos
          ? `<b>Fotos do produto</b> "${produto.descricao}<br>`
          : "";
    });
    return erro;
  }

  return {
    atualizarProdutos,
    atualizarUsuarioConfiguracoes,
    buscarMarketplaces,
    buscarMarketplacesEmpresa,
    buscarProdutosNaoVinculados,
    desvincularMarketplace,
    excluirAnuncios,
    pesquisar,
    sincronizarProdutos,
    vincularMarketplace,
    vincularAnuncio,
  };
}
